import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import msal from "vue-msal";
import vuetify from "./plugins/vuetify";
import wb from "./registerServiceWorker";
Vue.config.productionTip = false;

// Vue.use(msal, {
// 	auth: {
// 		clientId: "314c8cad-c1be-47d7-a62c-ca0f6a0bedc4",
// 		tenantId: "642fd61c-34dd-4fd0-af8d-443576485883",
// 		redirectUri: "https://localhost:8080/.auth/login/aad/callback", //dev
// 		requireAuthOnInitialize: true,
// 	},
// 	cache: {
// 		cacheLocation: "sessionStorage",
// 	},
// 	graph: {
// 		callAfterInit: true,
// 		endpoints: {
// 			profile: "/me",
// 		},
// 	},
// });

Vue.prototype.$workbox = wb;

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount("#app");
